import { render, staticRenderFns } from "./TmallWishlistNotification.vue?vue&type=template&id=d9b1e8d4"
import script from "./TmallWishlistNotification.vue?vue&type=script&lang=js"
export * from "./TmallWishlistNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports